<div class="breadcrumb-wrapper">
    <div title="Clique para voltar ao início" [innerHTML]="colorService.svgList.home_svg.htmlText" class="home-icon" [routerLink]="['/conference-map']" alt=""></div>
  <div class="breadcrumb-item" *ngFor="let item of items; let first = first">
    <div class="breadcrumb-container" tabindex="0" role="link" [ngClass]="{'router-link': !!item.route}" (click)="navigate(item.route, item.queryParams)">
      <h2>{{item.title}}</h2>
      <span *ngIf="item.subTitle">{{item.subTitle}}</span>
    </div>
    <div [innerHTML]="colorService.svgList.arrow_right_svg.htmlText" class="arrow-right"></div>
  </div>
</div>
